import { Code } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { variants } from '../../../variants/variants';
import NavbarLayout from '../../../common/NavbarLayout';
import { useNavigate } from 'react-router-dom';

const HomeNavbar = () => {
  const navigate = useNavigate()
  const handleNavigateBack = () => {
    navigate('/')
  }
  return (
    <NavbarLayout handleNavigate={handleNavigateBack}>
    <Grid item display={'flex'} justifyContent={'start'}>
      <Code sx={variants.icon.active} />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography component={'div'} ml={1}>
          Team Linkway <Typography fontSize={variants.BODY}>Meet the developers</Typography>
        </Typography>
      </Box>
    </Grid>
    </NavbarLayout>
  );
};

export default HomeNavbar;
